import { useState } from 'react';
import { Star } from 'lucide-react';
import { tenantApi } from '../api.js';
import { useTenantSession } from '../auth-context.js';
import { useInvalidate } from '../query.js';

export function TemplateFavoriteStar({
  templateId,
  favorited,
}: {
  templateId: string;
  favorited: boolean;
}) {
  const { token } = useTenantSession();
  const invalidate = useInvalidate();
  const [busy, setBusy] = useState(false);

  const toggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!token || busy) return;
    setBusy(true);
    try {
      if (favorited) {
        await tenantApi.templates.unfavorite({ template_id: templateId });
      } else {
        await tenantApi.templates.favorite({ template_id: templateId });
      }
      await invalidate('templates.list');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={(e) => void toggle(e)}
      disabled={busy}
      aria-label={favorited ? 'Ta bort favorit' : 'Markera som favorit'}
      aria-pressed={favorited}
      className="rounded p-1 text-stone-400 hover:text-amber-500 disabled:opacity-50"
    >
      <Star
        size={16}
        className={favorited ? 'fill-amber-400 text-amber-500' : ''}
      />
    </button>
  );
}

/**
 * Stable sort that floats favorited templates to the top while
 * preserving the backend's category/name ordering within each bucket.
 */
export function sortFavoritesFirst<T extends { favorited: boolean }>(rows: T[]): T[] {
  return [...rows].sort((a, b) => Number(b.favorited) - Number(a.favorited));
}
